import styled from 'styled-components'

export const FormContainer = styled.div``

export const List = styled.ul`
  max-height: 490px;
  width: 400px;
`
